import React from 'react';

import { theme } from '@waglabs/base-theme';
import {
  Box,
  BoxProps,
} from '@waglabs/box-next';

export type FieldLegendProps = BoxProps;
export const FieldLegend = (props: FieldLegendProps) => (
  <Box
    as="legend"
    fontSize="16px"
    color={theme.colors.charcoal}
    position="absolute"
    top={0}
    mt={0}
    {...props}
  />
);
